module.exports = __webpack_public_path__ + "static/media/16.a2d964a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/16.png
// module id = 518
// module chunks = 0